import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/helpers/SelectedWorkspaceContext";
import useAppStore from "common/hooks/useAppStore";

import { get, HTTPError } from "../helpers/HTTP";

import type { PaymentSource } from "../types";

async function getPaymentSource(
  workspaceId: string,
  subscriptionId: string,
): Promise<PaymentSource> {
  try {
    const { payment_source: paymentSource } = await get(
      `workspaces/${workspaceId}/subscriptions/${subscriptionId}/payment-source`,
    );

    // This is a temporary fix, until the backend resolves the issue with correct caching of payment source, when the card is removed through Chargebee
    return paymentSource.type ? paymentSource : null;
  } catch (err) {
    if (err instanceof HTTPError && err.code === 404) {
      return null;
    }
    throw err;
  }
}
async function getPaymentSourceWithoutWorkspace(): Promise<PaymentSource> {
  try {
    const { payment_source: paymentSource } = await get(
      `subscriptions/payment-source`,
    );

    // This is a temporary fix, until the backend resolves the issue with correct caching of payment source, when the card is removed through Chargebee
    return paymentSource.type ? paymentSource : null;
  } catch (err) {
    if (err instanceof HTTPError && err.code === 404) {
      return null;
    }
    throw err;
  }
}

export default function usePaymentSource(subscriptionId: string) {
  const selectedWorkspace = useSelectedWorkspaceContext();

  const isPaymentMethodHidden = useAppStore(
    (state) => state.debugOptions.isPaymentMethodHidden,
  );

  const { data: paymentSource, isLoading: isLoadingPaymentSource } = useQuery({
    queryKey: [subscriptionId, "primaryPaymentSource"],
    queryFn: () =>
      selectedWorkspace
        ? getPaymentSource(selectedWorkspace.id, subscriptionId)
        : getPaymentSourceWithoutWorkspace(),
    enabled: !!subscriptionId,
  });

  return {
    paymentSource: isPaymentMethodHidden ? null : paymentSource,
    isLoadingPaymentSource,
  };
}
